import { render, staticRenderFns } from "./TierComparisonOptions.vue?vue&type=template&id=292501ed&scoped=true&"
import script from "./TierComparisonOptions.vue?vue&type=script&lang=js&"
export * from "./TierComparisonOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292501ed",
  null
  
)

export default component.exports